// 设置带有过期时间的localStorage项
export function setLocalStorageWithExpiry(key, value, ttl) {
    const now = new Date();
    // ttl是过期时间（单位：毫秒）
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }
   
// 获取localStorage项，检查是否过期
export function getLocalStorageWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
}
 